import { EntityData } from "@/components/TriggerSetup/logic/types/entity-data.type";
import { baseCondition } from "@/components/TriggerSetup/logic/structures/base-condition.structure";
import { TriggerCondition } from "@/components/TriggerSetup/logic/types/types";
import { snakeCase } from "lodash";
import { getTagsByFieldKey } from '@/mixins/TariffsTagsHelper'
import SourceTitleSetupView from './SourceTitleSetupView.vue'

const condition: () => EntityData = () => {
  return {
    'setupView': SourceTitleSetupView,
    'structure': {
      'type': 'SourceTitle',
      ...baseCondition,
    } as TriggerCondition,
    'titleKey': `trigger_condition_${ snakeCase('SourceTitle') }`,
    'limited': getTagsByFieldKey('SourceTitleCondition'),
  }
}

export default condition
